import React, { FC } from 'react';
import styled from 'styled-components';
import { ExpandibleCardMobile, Space } from '~/components/index';
import DeleteButton from '~/components/views/ShareholdersMultiple/DeleteButton';
import EditButton from '~/components/views/ShareholdersMultiple/EditButton';
import colors from '~/constants/colors';
import classNames from 'classnames';

interface Props {
  fields: React.ReactElement[];
  onEdit?: () => void;
  onDelete?: () => void;
  disableEditAction?: boolean;
  disableDeleteAction?: boolean;
  hasValidationWarnings: boolean;
}

const TableCardMobile: FC<Props> = (props) => {
  const {
    onEdit,
    onDelete,
    disableEditAction,
    disableDeleteAction,
    hasValidationWarnings,
    fields,
  } = props;

  return (
    <StyledTableCardMobile
      className={classNames({
        'IndividualCardMobile-Warning': hasValidationWarnings,
      })}
    >
      {Array.isArray(fields) &&
        fields.concat(
          onEdit ? (
            <div className="IndividualCardMobile-ButtonsCol">
              <Space size={16} fullWidth={false}>
                <EditButton
                  id="Table_EditButton"
                  className="IndividualCardMobile-Button"
                  disabled={disableEditAction}
                  onClick={onEdit}
                />
              </Space>
            </div>
          ) : (
            []
          ),
          onDelete ? (
            <div className="IndividualCardMobile-ButtonsCol">
              <Space size={16} fullWidth={false}>
                <DeleteButton
                  id="Table_DeleteButton"
                  className="IndividualCardMobile-Button"
                  disabled={disableDeleteAction}
                  onClick={onEdit}
                />
              </Space>
            </div>
          ) : (
            []
          )
        )}
    </StyledTableCardMobile>
  );
};

const StyledTableCardMobile = styled(ExpandibleCardMobile)`
  .IndividualCardMobile-ButtonsCol {
    display: flex;
    align-items: center;
    height: 100%;
    .anticon {
      color: inherit;
    }
    .IndividualCardMobile-Button {
      width: 32px;
      height: 32px;
      font-size: 16px;
    }
  }
  &.IndividualCardMobile-Warning {
    background-color: ${colors.warningBackground};
  }
`;

export default TableCardMobile;
